import { useAppInfo } from 'hooks/useAppInfo'
import { AppContext } from 'config/enums'

import { PfSupport } from './pf'
import { PjSupport } from './pj'
import { IaSupport } from './ia'
import { ArSupport } from './ar'
import { UbSupport } from './ub'

export default function Support() {
  const { appContext } = useAppInfo()

  switch (appContext) {
    case AppContext.PJ:
      return <PjSupport />
    case AppContext.IA:
      return <IaSupport />
    case AppContext.AR:
      return <ArSupport />
    case AppContext.UB:
      return <UbSupport />

    default:
      return <PfSupport />
  }
}
